import { Typography } from '@remarkable/ark-web';
import clsx from 'clsx';
import type { FleetUser } from 'src/api/endpoints/cloudEnterprise.types';
import { fleetUserHelpers } from './fleetUserHelpers';

export function CellUser({ user }: { user: FleetUser }) {
  const fullName = fleetUserHelpers.getName(user);
  const hasName = fleetUserHelpers.hasName(user);

  return (
    <div className="w-full">
      {hasName && (
        <Typography variant="interface-sm" className="truncate">
          {fullName}
        </Typography>
      )}
      <Typography
        variant={hasName ? 'interface-xs' : 'interface-sm'}
        className={clsx('mt-6 truncate', { 'text-text-muted': hasName })}
      >
        {fleetUserHelpers.getEmail(user)}
      </Typography>
    </div>
  );
}
